import { z } from 'zod';

// Attributes from ja/validation.php
const ATTR = {
  service_type: 'サービス区分',
  sheet_name: '用紙名',
  unit_amount: '用紙枚数',
  price: '用紙単価（税込）',
  sortno: '並び順',
  available_from: '適用開始日',
} as const;

// Message templates from ja/validation.php
const required = (attr: string) => `${attr}は必須です。`;
const integer = (attr: string) => `${attr}は整数にしてください。`;
const maxString = (attr: string, max: number) => `${attr}は${max}文字以下にしてください。`;

const INT_MAX = 2147483647;

const integerField = (attr: string) =>
  z
    .string()
    .trim()
    .min(1, required(attr))
    .refine(v => /^-?\d+$/.test(v) && Number(v) <= INT_MAX, integer(attr));

export const createRezeptSheetSchema = z
  .object({
    service_type: z
      .string({ required_error: required(ATTR.service_type), invalid_type_error: required(ATTR.service_type) })
      .nullish()
      .transform(v => v ?? '')
      .pipe(z.string().min(1, required(ATTR.service_type))),
    sheet_name: z.string().trim().min(1, required(ATTR.sheet_name)).max(50, maxString(ATTR.sheet_name, 50)),
    unit_amount: integerField(ATTR.unit_amount),
    price: integerField(ATTR.price),
    sortno: integerField(ATTR.sortno),
    available_from: z.string().trim().min(1, required(ATTR.available_from)),
    available_to: z.string().trim().nullable().optional(),
  })
  .refine(
    data => {
      if (!data.available_to || !data.available_from) return true;
      return data.available_to >= data.available_from;
    },
    {
      message: '適用終了日時は適用開始日時より後の日時を指定してください。',
      path: ['available_to'],
    }
  );

export type CreateRezeptSheetFormData = z.infer<typeof createRezeptSheetSchema>;
